import React, { useState, useCallback } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import WellnessPackages from "@/components/site/WellnessPackages";
import HomeCollectionSection from "@/components/site/HomeCollectionSection";
import HowItWorks from "@/components/site/HowItWorks";
import About from "@/components/site/About";
import WhyChoose from "@/components/site/WhyChoose";
import Hospitals from "@/components/site/Hospitals";
import Testimonials from "@/components/site/Testimonials";
import GoogleReviews from "@/components/site/GoogleReviews";
import InstagramSection from "@/components/site/InstagramSection";
import Careers from "@/components/site/Careers";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import CTASection from "@/components/site/CTASection";
import Footer from "@/components/site/Footer";
import FloatingButtons from "@/components/site/FloatingButtons";
import BookingModal from "@/components/site/BookingModal";

export default function Home() {
  const [booking, setBooking] = useState({ open: false, mode: "appointment", test: "" });

  const openAppointment = useCallback((test = "") => setBooking({ open: true, mode: "appointment", test: typeof test === "string" ? test : "" }), []);
  const openHome = useCallback(() => setBooking({ open: true, mode: "home", test: "" }), []);

  return (
    <div className="bg-white" data-testid="home-page">
      <Navbar onBook={() => openAppointment()} />
      <main>
        <Hero onBook={() => openAppointment()} />
        <Stats />
        <Services onBook={openAppointment} />
        <WellnessPackages onBook={openAppointment} />
        <HomeCollectionSection onBook={openHome} />
        <HowItWorks />
        <About />
        <WhyChoose />
        <Hospitals />
        <Testimonials />
        <GoogleReviews />
        <InstagramSection />
        <Careers />
        <FAQ />
        <Contact />
        <CTASection onBook={() => openAppointment()} />
      </main>
      <Footer />
      <FloatingButtons onBook={() => openAppointment()} />
      <BookingModal open={booking.open} onOpenChange={(o) => setBooking((b) => ({ ...b, open: o }))} mode={booking.mode} presetTest={booking.test} />
    </div>
  );
}
